export const publicHolidaysByLanguage = /* GraphQL */ `
  query PublicHolidaysByLanguage($language: Language, $nextToken: String) {
    publicHolidays: publicHolidaysByLanguage(
      language: $language
      nextToken: $nextToken
    ) {
      items {
        startDate
        language
        title
        label
      }
      nextToken
    }
  }
`;
